<script>
import Layout from "../../layouts/main";
export default {
  page: {
    title: "Reports",
    meta: [{ name: "description", content: '' }],
  },
  components: {
    Layout,
  },

  data() {
    return {

    };
  },
};
</script>

<template>
  <Layout>
  </Layout>
</template>
